(() => {
  'use strict';
  const root = document.getElementById('kinetic-upgrade');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const engine = window.KineticUpgrade;
  const $ = selector => root.querySelector(selector);
  const form = $('#kmu-preferences');
  const status = $('#kmu-status');
  const results = $('#kmu-results');
  const detail = $('#kmu-detail');
  const currency = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });
  const money = cents => currency.format(cents / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const safeImage = value => {
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && /(^|\.)(shopify\.com|shopifycdn\.com|kineticmobiles\.es)$/.test(url.hostname) ? url.href : ''; } catch { return ''; }
  };
  const safeSource = value => {
    try { const url = new URL(value); return url.protocol === 'https:' && /(^|\.)(apple\.com|google\.com|samsung\.com|mi\.com|motorola\.com)$/.test(url.hostname) ? url.href : ''; } catch { return ''; }
  };
  const productUrl = (product, variant = product.variantId) => `/products/${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(variant)}`;
  const scrollTo = node => {
    node.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  };
  const record = (name, extra = {}) => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...extra });
  };
  const storageKey = 'kinetic-upgrade-preferences-v1';
  let catalogPromise;
  let products = [];
  let choices = [];
  let prefs;
  let selected;
  let submission = 0;

  if (!engine?.normalizeProducts || !Array.isArray(engine.profiles)) {
    status.innerHTML = 'Match no se ha podido cargar. <a href="/collections/todos-los-telefonos">Ver todos los móviles</a>.';
    $('#kmu-submit').disabled = true;
    return;
  }
  for (const profile of engine.profiles) {
    const option = document.createElement('option');
    option.value = profile.id;
    option.textContent = profile.name;
    $('#kmu-current').append(option);
  }
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved && typeof saved === 'object') {
      if (Number.isInteger(saved.budget) && saved.budget >= 6000 && saved.budget <= 300000) $('#kmu-budget').value = saved.budget / 100;
      for (const key of ['current', 'condition', 'system', 'priority']) {
        const controls = Array.from(form.elements).filter(control => control.name === key);
        for (const control of controls) {
          if (control.type === 'radio') control.checked = control.value === saved[key];
          else if (Array.from(control.options || []).some(option => option.value === saved[key])) control.value = saved[key];
        }
      }
    }
  } catch { /* The finder also works when session storage is disabled. */ }
  const initialPhone = new URLSearchParams(location.search).get('current');
  if (engine.profiles.some(profile => profile.id === initialPhone)) $('#kmu-current').value = initialPhone;

  async function getJson(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 18000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal, headers: { Accept: 'application/json', ...options.headers } });
      const data = await response.json();
      if (!response.ok) throw new Error(response.status === 422 ? 'Este artículo acaba de cambiar de disponibilidad. Revisa la ficha para elegir otra opción.' : 'No hemos podido conectar con la tienda. Inténtalo de nuevo.');
      return data;
    } finally { clearTimeout(timer); }
  }
  async function loadCatalog() {
    if (!catalogPromise) {
      catalogPromise = (async () => {
        const catalog = [];
        for (let page = 1; page <= 4; page += 1) {
          const data = await getJson(`/collections/todos-los-telefonos/products.json?limit=250&page=${page}`);
          if (!Array.isArray(data.products)) throw new Error('El catálogo no está disponible en este momento.');
          catalog.push(...data.products);
          if (data.products.length < 250) break;
        }
        return engine.normalizeProducts(catalog).filter(product => safeImage(product.image));
      })().catch(error => { catalogPromise = null; throw error; });
    }
    return catalogPromise;
  }
  const readPrefs = () => {
    const data = new FormData(form);
    return { budget: Math.round(Number(data.get('budget')) * 100), current: data.get('current') || '', condition: data.get('condition') || 'any', system: data.get('system') || 'any', priority: data.get('priority') || 'value' };
  };
  const conditionName = product => product.condition === 'refurbished' ? 'Reacondicionado' : 'Nuevo';

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const requestId = ++submission;
    prefs = readPrefs();
    if (!Number.isInteger(prefs.budget) || prefs.budget < 6000 || prefs.budget > 300000) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify(prefs)); } catch { /* Nonessential persistence. */ }
    $('#kmu-submit').disabled = true;
    $('#kmu-submit').setAttribute('aria-busy', 'true');
    results.hidden = true;
    detail.hidden = true;
    status.textContent = 'Comprobando modelos, variantes y precios…';
    record('kinetic_upgrade_start', { budget: prefs.budget / 100, priority: prefs.priority, system: prefs.system });
    try {
      products = await loadCatalog();
      if (requestId !== submission) return;
      choices = engine.recommend(products, prefs);
      if (!choices.length) {
        status.innerHTML = 'No hay modelos que cumplan todas estas preferencias ahora mismo. Puedes cambiar el presupuesto o el estado del móvil. <a href="/collections/todos-los-telefonos">Ver el catálogo completo</a>.';
        return;
      }
      status.textContent = '';
      const systemLabel = { any: 'iPhone y Android', apple: 'iPhone', android: 'Android' }[prefs.system];
      $('#kmu-results-summary').textContent = `${choices.length} ${choices.length === 1 ? 'opción' : 'opciones'} · Hasta ${money(prefs.budget)} · ${systemLabel}`;
      $('#kmu-result-grid').innerHTML = choices.map((choice, index) => {
        const product = choice.product;
        const role = { best: 'La elección para ti', save: 'Para gastar menos', stepup: 'Un paso más' }[choice.role] || 'Otra opción que encaja';
        return `<article class="kmu-result" data-choice="${index}" aria-current="false">
          <p class="kmu-result-role">${esc(role)}</p>
          <a class="kmu-result-photo" href="${productUrl(product)}" aria-label="${esc(product.title)}"><img src="${esc(safeImage(product.image))}" alt="${esc(product.title)}" width="240" height="180" loading="lazy"></a>
          <h3>${esc(product.shortTitle || product.title)}</h3><span class="kmu-tag">${conditionName(product)}</span>
          <p class="kmu-result-price">${esc(money(product.price))}<span>${esc(money(prefs.budget - product.price))} por debajo del límite</span></p>
          <ul class="kmu-reasons">${(choice.reasons || []).filter(reason => !reason.startsWith('Precio de la variante:')).slice(0, 3).map(reason => `<li>${esc(reason)}</li>`).join('')}</ul>
          <p class="kmu-limit"><strong>A tener en cuenta:</strong> ${esc(choice.limitation || 'Consulta los detalles de esta variante en su ficha.')}</p>
          <button type="button" class="kmu-btn ${index ? 'kmu-btn--secondary' : ''}" data-select="${index}">${prefs.current ? 'Comparar con mi móvil' : 'Ver mi elección'} <i class="sli-arrow-right" aria-hidden="true"></i></button>
          <a href="${productUrl(product)}">Ver ficha completa</a>
        </article>`;
      }).join('');
      results.hidden = false;
      record('kinetic_upgrade_results', { count: choices.length, products: choices.map(choice => choice.product.id) });
      $('#kmu-results-title').focus({ preventScroll: true });
      scrollTo(results);
    } catch (error) {
      status.textContent = error.name === 'AbortError' ? 'La conexión está tardando demasiado. Vuelve a pulsar «Encontrar mi móvil».' : `${error.message} Vuelve a pulsar «Encontrar mi móvil».`;
    } finally {
      $('#kmu-submit').disabled = false;
      $('#kmu-submit').removeAttribute('aria-busy');
    }
  });
  $('#kmu-edit').addEventListener('click', () => { scrollTo(form); $('#kmu-current').focus({ preventScroll: true }); });
  $('#kmu-result-grid').addEventListener('click', event => {
    const button = event.target.closest('[data-select]');
    if (!button) return;
    const index = Number(button.dataset.select);
    if (!choices[index]) return;
    selected = choices[index].product;
    for (const card of root.querySelectorAll('[data-choice]')) card.setAttribute('aria-current', String(Number(card.dataset.choice) === index));
    renderDetail(selected);
    record('kinetic_upgrade_select', { product_id: selected.id, variant_id: selected.variantId });
  });

  function renderDetail(product) {
    const choice = choices.find(item => item.product.id === product.id) || {};
    const current = engine.profiles.find(profile => profile.id === prefs.current);
    const next = product.profile;
    const rows = current && next ? engine.compare(current, next) : [];
    const variants = product.variants.filter(variant => variant.available && variant.price <= prefs.budget);
    if (!variants.length) return;
    const canScale = current && next && [current.width, current.height, next.width, next.height].every(value => Number.isFinite(value) && value > 0 && value < 250);
    const sourceLinks = [current, next, choice.source ? { source: choice.source, name: product.shortTitle } : null].filter(Boolean).filter((profile, index, list) => list.findIndex(item => item.source === profile.source) === index).map(profile => safeSource(profile.source) ? `<a href="${esc(safeSource(profile.source))}" target="_blank" rel="noopener">Ficha oficial: ${esc(profile.name)}</a>` : '').join('');
    detail.innerHTML = `<div class="kmu-section-heading"><div><p class="kmu-eyebrow">TU CAMBIO, AL DETALLE</p><h2 id="kmu-detail-title" tabindex="-1">${esc(product.shortTitle || product.title)}</h2></div><a href="${productUrl(product)}" class="kmu-icon-btn" title="Abrir ficha del producto" aria-label="Abrir ficha del producto"><i class="sli-arrow-right" aria-hidden="true"></i></a></div>
      <div class="kmu-detail-layout kmu-fade">
        <div class="kmu-detail-visual"><img class="kmu-detail-photo" src="${esc(safeImage(product.image))}" alt="${esc(product.title)}" width="420" height="300">
          ${canScale ? `<details class="kmu-size-toggle"><summary>Comparar el tamaño con mi móvil</summary><div class="kmu-scale" aria-label="Comparación de las dimensiones exteriores"><div class="kmu-phone-outline" style="--phone-h:${current.height};--phone-w:${current.width}"><span>${esc(current.name)}</span></div><div class="kmu-phone-outline" style="--phone-h:${next.height};--phone-w:${next.width}"><span>${esc(next.name)}</span></div></div><label class="kmu-scale-controls" for="kmu-overlap">Superposición<input id="kmu-overlap" aria-label="Superposición de los tamaños" type="range" min="0" max="${Math.round(Math.min(current.width, next.width) * 1.12)}" value="0"></label><p class="kmu-scale-note">Proporciones relativas del dispositivo. No es tamaño real en pantalla.</p></details>` : ''}
        </div>
        <div>
          ${current && next && current.id === next.id ? '<p class="kmu-small">Es el mismo modelo que tienes. El estado y la capacidad pueden cambiar, pero no supone un salto de generación.</p>' : ''}
          ${rows.length ? `<table class="kmu-compare"><caption class="sr-only">Comparativa técnica entre tu móvil y tu elección</caption><thead><tr><th scope="col">Característica</th><th scope="col">${esc(current.name)}</th><th scope="col">${esc(next.name)}</th></tr></thead><tbody>${rows.map(row => `<tr><th scope="row">${esc(row.label)}</th><td>${esc(row.before)}</td><td>${esc(row.after)}${row.note ? `<br><small>${esc(row.note)}</small>` : ''}</td></tr>`).join('')}</tbody></table>` : `<p class="kmu-small">${current ? 'Todavía no tenemos una ficha técnica contrastada para comparar este modelo con el tuyo.' : 'Puedes elegir tu móvil actual arriba para comparar características verificadas.'} El precio y las variantes proceden del catálogo de la tienda.</p>`}
          ${sourceLinks ? `<p class="kmu-sources">${sourceLinks}</p>` : ''}
          <form class="kmu-buy" id="kmu-buy-form"><label for="kmu-variant">Tu variante<select id="kmu-variant" name="variant">${variants.map(variant => `<option value="${esc(variant.id)}" ${String(variant.id) === String(product.variantId) ? 'selected' : ''}>${esc(variant.title === 'Default Title' ? product.shortTitle || product.title : variant.title)} · ${esc(money(variant.price))}</option>`).join('')}</select></label>
            <div class="kmu-buy-total"><strong id="kmu-live-price">${esc(money(product.price))}</strong><span>IVA incluido</span></div><p class="kmu-small" id="kmu-budget-left">${esc(money(prefs.budget - product.price))} por debajo de tu presupuesto</p>
            <p class="kmu-small">Envío gratis en España. Plazo y opciones de entrega al finalizar la compra.</p>
            <button class="kmu-btn" id="kmu-add" type="submit"><i class="sli-bag" aria-hidden="true"></i> Añadir al carrito</button><p class="kmu-buy-status" id="kmu-buy-status" role="status" aria-live="polite"></p>
          </form>
          <div class="kmu-next-steps"><a data-next="trade" href="/pages/cambio-kinetic?product=${encodeURIComponent(product.handle)}">Tasa tu móvil</a><a data-next="reserve" href="/pages/reserva-en-tienda?product=${encodeURIComponent(product.handle)}">Verlo en tienda</a><a data-next="pack" href="/pages/pack-inteligente?product=${encodeURIComponent(product.handle)}">Consultar protección</a>${product.condition === 'refurbished' ? `<a href="${productUrl(product)}#km-unit-passport">Fotos y estado de la unidad</a>` : ''}</div>
        </div>
      </div>`;
    detail.hidden = false;
    const select = $('#kmu-variant');
    const updateVariant = () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      $('#kmu-live-price').textContent = money(variant.price);
      $('#kmu-budget-left').textContent = `${money(prefs.budget - variant.price)} por debajo de tu presupuesto`;
      for (const link of detail.querySelectorAll('[data-next]')) { const url = new URL(link.href); url.searchParams.set('variant', variant.id); link.href = url.pathname + url.search; }
      $('#kmu-buy-status').textContent = '';
    };
    select.addEventListener('change', updateVariant);
    updateVariant();
    $('#kmu-overlap')?.addEventListener('input', event => detail.querySelector('.kmu-scale').style.setProperty('--overlap', event.target.value));
    $('#kmu-buy-form').addEventListener('submit', async event => {
      event.preventDefault();
      const button = $('#kmu-add');
      const notice = $('#kmu-buy-status');
      const variantId = select.value;
      if (button.disabled || !variants.some(variant => String(variant.id) === variantId)) return;
      button.disabled = true;
      select.disabled = true;
      button.setAttribute('aria-busy', 'true');
      notice.textContent = 'Confirmando precio y disponibilidad…';
      try {
        const fresh = await getJson(`/products/${encodeURIComponent(product.handle)}.js`);
        const variant = fresh.variants?.find(item => String(item.id) === variantId);
        if (!variant?.available) throw new Error('Esta variante ya no está disponible. Elige otra en la ficha del producto.');
        if (!Number.isSafeInteger(variant.price) || variant.price > prefs.budget) throw new Error('El precio ha cambiado y supera tu presupuesto. Vuelve a buscar para actualizar la selección.');
        const shown = variants.find(item => String(item.id) === variantId);
        if (variant.price !== shown.price) {
          shown.price = variant.price;
          select.selectedOptions[0].textContent = `${shown.title === 'Default Title' ? product.shortTitle || product.title : shown.title} · ${money(variant.price)}`;
          updateVariant();
          notice.textContent = `El precio se ha actualizado a ${money(variant.price)}. Confírmalo pulsando de nuevo «Añadir al carrito».`;
          return;
        }
        await getJson('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
        record('kinetic_upgrade_add_to_cart', { product_id: product.id, variant_id: variant.id, value: variant.price / 100, currency: 'EUR' });
        notice.innerHTML = 'Añadido a tu carrito. <a href="/cart">Ver carrito y finalizar compra <i class="sli-arrow-right" aria-hidden="true"></i></a>';
        button.innerHTML = '<i class="sli-check" aria-hidden="true"></i> Añadido al carrito';
        button.dataset.added = 'true';
        window.location.assign('/cart');
      } catch (error) {
        notice.textContent = error.name === 'AbortError' ? 'La respuesta ha tardado demasiado. Revisa tu carrito antes de volver a añadirlo.' : error.message;
        if (error.name === 'AbortError') notice.insertAdjacentHTML('beforeend', ' <a href="/cart">Revisar carrito</a>');
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = button.dataset.added === 'true';
        select.disabled = false;
      }
    });
    select.addEventListener('change', () => { const button = $('#kmu-add'); button.disabled = false; delete button.dataset.added; button.innerHTML = '<i class="sli-bag" aria-hidden="true"></i> Añadir al carrito'; });
    $('#kmu-detail-title').focus({ preventScroll: true });
    scrollTo(detail);
  }
  $('#kmu-submit').disabled = false;
})();
